var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameroon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9564 1.60032C20.8529 0.583195 18.493 0.0126953 15.9999 0.0126953C13.5068 0.0126953 11.1469 0.583195 9.04341 1.60032L7.6521 16.0127L9.04341 30.4251C11.1469 31.4422 13.5068 32.0127 15.9999 32.0127C18.493 32.0127 20.8529 31.4422 22.9564 30.4251L24.3477 16.0127L22.9564 1.60032Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 10.4475L17.3811 14.6987H21.8516L18.2351 17.3264L19.6164 21.5779L15.9998 18.9503L12.3833 21.5779L13.7648 17.3264L10.1483 14.6987H14.6185L15.9998 10.4475Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 1.60098C3.69163 4.18886 0 9.66942 0 16.0128C0 22.3562 3.69163 27.8367 9.0435 30.4246V1.60098Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9563 1.60098V30.4246C28.3082 27.8367 31.9998 22.3561 31.9998 16.0128C31.9998 9.66948 28.3082 4.18886 22.9563 1.60098Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0126953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameroon);
export default __webpack_public_path__ + "static/media/cameroon.a3ecf933.svg";
export { ForwardRef as ReactComponent };